import { t } from 'i18next'
import React from 'react'
import { Box, Typography } from '@mui/material'

function Footer({ training, slowTraining }) {
    var asterisks = [t('pdf:footer:mentionIA'), t('pdf:footer:firstAsterisk')];

    if (!training || slowTraining) {
        return null;
    }
    
    var parameterNames = training.insight_items
        .filter((item) => item.insight_parameter != null)
        .map((item) => item.insight_parameter.name);

    if (parameterNames.includes("insight.max_speed")) {
        asterisks.push(t('pdf:footer:secondAsterisk'));
    }

    if (parameterNames.includes("insight.stride_frequency_at_60")) {
        asterisks.push(t('pdf:footer:thirdAsterisk'));
    }

    return (
        <Box 
            sx={{ 
                px: 1, 
                pt: 1, 
                width: '100%', 
                display: 'flex', 
                justifyContent: 'flex-start' 
            }}
        >
            <Box>
                {asterisks.map((text, index) => (
                    <Typography 
                        key={index} 
                        component="div" 
                        sx={{ fontSize: '0.575rem', lineHeight: '0.80rem' }}
                    >
                        {'*'.repeat(index + 1).concat(text)}
                    </Typography>
                ))}
            </Box>
        </Box>
    );
}

export default Footer